import Vue from 'vue';
import VueCroppie from 'vue-croppie';
import 'croppie/croppie.css';

Vue.use(VueCroppie);
